import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import useConsentStore from "../../store/consentStore";

interface MobileNavType {
  hasLeavingQuestionnaire: boolean;
  isOpen: boolean;
  close: () => void;
}

const MobileNav = ({
  hasLeavingQuestionnaire,
  isOpen,
  close,
}: MobileNavType) => {
  const { consentsOnline } = useConsentStore();

  const mobileLinkSx = {
    borderRadius: 1,
    px: 1.5,
    py: 1,
    color: "black",
    fontWeight: 400,
    textDecoration: "none",
    "&.active": {
      backgroundColor: "#f1f3f5",
      fontWeight: 700,
    },
    "& .MuiListItemText-primary": {
      color: "inherit",
      fontWeight: "inherit",
    },
  };

  return (
    <Drawer anchor={"left"} open={isOpen} onClose={close}>
      <Box sx={{ width: 240, p: 1 }} onClick={close}>
        <List>
          <ListItem disablePadding>
            <ListItemButton component={NavLink} to="/" sx={mobileLinkSx}>
              <ListItemText primary={"Rozcestník"} />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton
              component={NavLink}
              to="/dotazniky"
              sx={mobileLinkSx}
            >
              <ListItemText primary={"Dotazníky"} />
            </ListItemButton>
          </ListItem>

          {hasLeavingQuestionnaire && (
            <ListItem disablePadding>
              <ListItemButton
                component={NavLink}
                to="/dotaznikvystup"
                sx={mobileLinkSx}
              >
                <ListItemText primary={"Výstupní dotazníky"} />
              </ListItemButton>
            </ListItem>
          )}
          <ListItem disablePadding>
            <ListItemButton
              component={NavLink}
              to="/dokumenty"
              sx={mobileLinkSx}
            >
              <ListItemText primary={"Šanon"} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton component={NavLink} to="/manualy" sx={mobileLinkSx}>
              <ListItemText primary={"Manuály"} />
            </ListItemButton>
          </ListItem>
          {consentsOnline.length > 0 && (
            <ListItem disablePadding>
              <ListItemButton
                component={NavLink}
                to="/consent"
                sx={mobileLinkSx}
              >
                <ListItemText primary={"Elektronická komunikace"} />
              </ListItemButton>
            </ListItem>
          )}
        </List>
      </Box>
    </Drawer>
  );
};

export default MobileNav;
